<app-carousel-scroll
  [items]="selectedEvent"
  [itemSize]="itemSize"
  [autoScroll]="false"
  [height]="'13rem'"
  *transloco="let t;"
  >
  <ng-template let-item="item" let-i="index">
    <mat-card class="custom-border-left my-3 summary__card mr-3 card">
      <mat-card-content class="card__content">
        <div class="card__content__name">
          {{ eventsArray?.[item]?.properties.name }}
        </div>
        <div class="card__content__text my-2">
          {{ eventsArray?.[item]?.properties?.dateStart | date: 'mediumDate':'':('language.locale' | transloco) }}
          @if (eventsArray?.[item]?.properties.showTime) {
            {{ eventsArray?.[item]?.properties.dateStart | date: 'shortTime':'':('language.locale' | transloco) }}
          }
          @if (eventsArray?.[item]?.properties.dateEnd) {
            - {{ eventsArray?.[item]?.properties.dateEnd | date: 'mediumDate':'':('language.locale' | transloco) }}
          }
        </div>
        <div class="d-flex --space-between --first-baseline">
          <a
            [href]="'/e/n/' + eventsArray?.[item]?.properties.url"
            class="card__content__text link --primary my-2"
            >
            {{ t('events.openMarketplace') }}
          </a>
          <p class="card__content__text"> {{ i + 1 }} / {{ selectedEvent?.length}} </p>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>
</app-carousel-scroll>
